/**
 * Runtime type guard to distinguish JSON Schema parameters from the
 * legacy `ParameterDefinition[]` format.
 *
 * @returns `true` if `params` is a JSON Schema object (has `type: "object"`
 *          and `properties`), `false` if it's a legacy array.
 */
export function isJSONSchemaParameters(params) {
    return (!Array.isArray(params) &&
        typeof params === "object" &&
        params !== null &&
        params.type === "object" &&
        typeof params.properties === "object" &&
        params.properties !== null);
}
//# sourceMappingURL=types.js.map